var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.footerContent && !_vm.isLoadingFooterContent)?_c('div',[_c('div',{class:_vm.textClass,domProps:{"innerHTML":_vm._s(_vm.footerContent)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }